import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "url(#a)",
      d: "M8.787 7.081c0-.316-.004-.592.001-.867.023-1.208.89-2.068 2.11-2.083q1.176-.016 2.351 0c1.211.018 2.088.9 2.1 2.098.003.275 0 .55 0 .855.713 0 1.4-.017 2.087.005.848.026 1.58.334 2.14.983.346.398.541.86.541 1.391.002 2.55.012 5.1-.005 7.65-.007 1.16-.961 2.147-2.226 2.332-.43.062-.87.057-1.346.085.017.373-.008.767-.385.982-.174.1-.402.16-.603.154-.51-.014-.76-.38-.821-1.142H9.379c.01.374-.007.761-.371.977a1.2 1.2 0 0 1-.6.166c-.52-.006-.771-.365-.844-1.164q-.621-.002-1.247 0c-.467.001-.909-.099-1.307-.342C4.36 18.763 4 18.192 4 17.42c0-2.752-.004-5.506.002-8.26.002-1.155.934-2.046 2.174-2.075.755-.017 1.51-.004 2.266-.005zm4.77-.012c0-.301.006-.586-.003-.87-.006-.184-.115-.292-.304-.292-.793-.003-1.586-.011-2.378.01-.1.004-.263.163-.277.266-.039.288-.014.583-.014.886h2.975"
    }, null, -1),
    _createElementVNode("defs", null, [
      _createElementVNode("linearGradient", {
        id: "a",
        x1: "6.82",
        x2: "23.827",
        y1: "20.021",
        y2: "11.735",
        gradientUnits: "userSpaceOnUse"
      }, [
        _createElementVNode("stop", {
          "stop-color": "#4EBC73",
          "stop-opacity": ".3"
        }),
        _createElementVNode("stop", {
          offset: "1",
          "stop-color": "#4EBC73"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }